import { PayoutSettings } from "@wingspanhq/wingspan-api-sdk";

export const selectorPayoutSettingsInstantFee = (
  payoutSettings?: PayoutSettings
): number => payoutSettings?.accountInstantPayoutFee?.percentage ?? 1;
